import {rejectCustomerOffer} from "@project/sdk/sales";
import {RejectCustomerOfferResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function rejectCustomerOfferMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.rejectCustomerOffer,
    mutationFn: async (id: string) =>
      RejectCustomerOfferResponse.parse(await rejectCustomerOffer(id)),
    onSuccess: async (_result, ownerId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(ownerId)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
